import { createDefault } from "../../utils/ConstUtils";

export default createDefault([{ value: 1, text: "新規作成", enum: "NEW" }]);
